document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper('.images-sliders', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        const progressLine = document.querySelector(".progress");
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                on: {
                autoplayTimeLeft(s, time, progress) {
                    progressLine.style.setProperty("width", Math.abs(progress-1)*100+'%');
                }
            }
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper('.slider-slide', {
                loop: true,
                effect: "fade",
                autoHeight: true,
                keyboard: true,
                uniqueNavElements:false,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                }
            });
        });
    }

    let newSlider = document.querySelectorAll('.news-slider');
    if(newSlider){
        newSlider.forEach((item)=> {
            new Swiper('.news-slider', {
                slidesPerView: 1,
                rewind: true,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-new-next",
                    prevEl: ".sw-new-prev",
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 2,
                    }
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        let imgSlide = new Swiper('.img-slider', {
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
        });
        let gallerySlide = new Swiper('.gallery-slider', {
            watchSlidesProgress: true,
            slidesPerView: 1,
            loop: true,
            fadeEffect: {
                "crossFade": true
            },
            thumbs: {
                swiper: imgSlide,
            },
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                600: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
    }

    let galleryGrid = document.querySelectorAll('.gallery-grid');
    if(galleryGrid){
        galleryGrid.forEach((item)=> {
            new Swiper('.gallery-grid', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let awardsSlide = document.querySelectorAll('.awards-slide');
    if(awardsSlide){
        awardsSlide.forEach((item)=> {
            new Swiper('.awards-slide', {
                slidesPerView: 1,
                rewind: true,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let sliderSmall = document.querySelectorAll('.slider-small');
    if(sliderSmall){
        sliderSmall.forEach((item)=> {
            new Swiper('.slider-small', {
                rewind: true,
                autoHeight: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-sm-next",
                    prevEl: ".sw-sm-prev",
                }
            });
        });
    }

    let sliderNoImg = document.querySelectorAll('.slider-no-img');
    if(sliderNoImg){
        sliderNoImg.forEach((item)=> {
            new Swiper('.slider-no-img', {
                rewind: true,
                autoHeight: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-ni-next",
                    prevEl: ".sw-ni-prev",
                }
            });
        });
    }

});